export default __webpack_public_path__ + "static/media/chim4.c4002146.webp";